export default "__VITE_ASSET__e787c466__"